import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class ProductoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: ProductoItemViewModel[];
}

export class ProductoItemViewModel {
    public Id: number;
    public IdSolicitud: number;
    public Codigo: string;
    public FechaEnvio: Date;
    public TipoSolicitud: string;
    public EstadoSolicitud: string;
    public RazonSocial: string;
    public Provincia: string;
    public PuntoInspeccion: string;
    public PaisOrigen: string;
    public CodigoEppo: string;
    public CodigoTaric: string;
    public NombreComun: string;
    public NombreCientifico: string; //Todo:agaro. Añadido 28/07/2020.
    public Grupo: string;
    public Forma: string;
    public Nrc: string;
    public PesoNeto: number;
    public EsPredua: boolean;
    public CodigoTipoSolicitud: string;
    public FormatoSolicitud: string;
    public IdEstadoSolicitud: number;
    public SolicitudAsignada: number;
    public Matriculas: string;
    public Exportador: string;
    public CodigoTraces: string;
    public FechaLlegada: Date | null;
    public NumeroOmi: string;
}

export class FilterSearchingProductoViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {
        super();
        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);
        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }

    public IdPais: number | null;
    public IdProvincia: number | null;
    public IdPuntoInspeccion: number | null;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public EsPredua = false;
    //public EsPrevia: boolean = false;
    public IdGrupo: number | null;
    public IdForma: number | null;
    public CodigoTaric = '';
    public CodigoEppo = '';
    public NombreComun = '';
    public IdTipoSolicitud: number | null;
    public IdEstadoSolicitud: number | null;
    public IdUsuario = 0;
    public EsInspector: boolean;
    public EsCoordinador: boolean;
    public EsSolicitante: boolean;
    public EsGrabador: boolean;
    public Codigo = '';
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public TieneEnvioDeMuestras: number = EnumSiNoTodos.TODOS;

    public EsConsultas: boolean;
    public EsConsultasySolicitante: boolean;
    public Matriculas = '';
    public Exportador = '';
    public CodigoTraces = '';
}
